module.exports = __webpack_public_path__ + "img/switem.c05b88ff.png";